export function trampolines(fn) { // 讀取一開始的函數
  return (...args) => { // 將函數的參數讀取
    let result = fn(...args); // 第一次執行函數，如果獲得閉包函數，即進入while迴圈
    while (typeof result === 'function') result = result(); // 當每次執行函數時，ans的值都透過閉包保存，而因為已經回傳了閉包，所以函數執行完畢，即釋放Stack
    return result; // 迭代result至不再回傳閉包函數而是數值時，回傳數值
  };
}